import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { LoadCommerceLandingUseCase } from '../../../application/commerce-registry/use-cases/load-commerce-landing.use-case';
import { ENVIRONMENT } from '../../../../environments/environment';

/**
 * When RTDB marks `home_view: false`, the commerce must not show `/inicio`; redirect to the form.
 * Unknown commerce redirects to `/404` when mocks are disabled.
 */
export const registryCommerceInicioGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const load = inject(LoadCommerceLandingUseCase);
  const slug = route.parent?.paramMap.get('comercioSlug');
  if (!slug) {
    return router.parseUrl('/');
  }
  return load.execute(slug, null).pipe(
    take(1),
    map((landing) => {
      if (landing == null) {
        return ENVIRONMENT.mockEnabled ? true : router.createUrlTree(['/404']);
      }
      if (landing.home_view === false) {
        return router.createUrlTree(['/comercio', slug, 'formulario-registro']);
      }
      return true;
    }),
    catchError(() => of(ENVIRONMENT.mockEnabled ? true : router.createUrlTree(['/404']))),
  );
};
